import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {
  DynamicComponentsRenderingModule,
  LazyPictureModule,
  NoSanitizePipeModule
} from '@ed-clients/shared';

import {MarketingDataModule} from '../shared-across-dwg-only/marketing-data/marketing-data.module';
import {PostsListModule} from '../shared-across-dwg-only/posts-list/posts-list.module';
import {HomeRoutingModule} from './home-routing.module';
import {HomeComponent} from './home.component';
import {HomeDynamicComponent} from './home-dynamic-component/home-dynamic-component.component';
import {FindContactModule} from '../shared-across-dwg-only/find-contact/find-contact.module';
import {VideoTeaserModule} from '../shared-across-dwg-only/video-teaser/video-teaser.module';
import {PostsFiltersModule} from '../shared-across-dwg-only/posts-filter/posts-filters.module';

@NgModule({
  declarations: [HomeComponent, HomeDynamicComponent],
  imports: [
    CommonModule,
    DynamicComponentsRenderingModule,
    FindContactModule,
    HomeRoutingModule,
    LazyPictureModule,
    MarketingDataModule,
    MatIconModule,
    PostsListModule,
    PostsFiltersModule,
    VideoTeaserModule,
    NoSanitizePipeModule
  ]
})
export class HomeModule {
}
